var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareprofileicons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#1F1F1F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0482 23.3092C23.4378 23.3092 22.8916 23.5502 22.4739 23.9277L16.747 20.5944C16.7871 20.4096 16.8193 20.2249 16.8193 20.0321C16.8193 19.8394 16.7871 19.6546 16.747 19.4699L22.4096 16.1687C22.8434 16.5703 23.4137 16.8193 24.0482 16.8193C25.3815 16.8193 26.4578 15.743 26.4578 14.4096C26.4578 13.0763 25.3815 12 24.0482 12C22.7149 12 21.6386 13.0763 21.6386 14.4096C21.6386 14.6024 21.6707 14.7871 21.7108 14.9719L16.0482 18.2731C15.6145 17.8715 15.0442 17.6225 14.4096 17.6225C13.0763 17.6225 12 18.6988 12 20.0321C12 21.3655 13.0763 22.4418 14.4096 22.4418C15.0442 22.4418 15.6145 22.1928 16.0482 21.7912L21.7671 25.1325C21.7269 25.3012 21.7028 25.4779 21.7028 25.6546C21.7028 26.9478 22.755 28 24.0482 28C25.3414 28 26.3936 26.9478 26.3936 25.6546C26.3936 24.3614 25.3414 23.3092 24.0482 23.3092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareprofileicons);
export default __webpack_public_path__ + "static/media/shareprofileicons.4d611ab992ae556ef3c0e33dcda5c379.svg";
export { ForwardRef as ReactComponent };